<h2 mat-dialog-title>{{ 'Create Nationals Games' | translate }}</h2>

<form [formGroup]="nationalGameForm">
  <div mat-dialog-content>
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
      <mat-form-field appearance="outline" style="width: 45%;">
        <mat-label>Home Team Name</mat-label>
        <input formControlName="homeTeam" matInput placeholder="Enter Home Team Name"/>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%;">
        <mat-label>Away Team Name</mat-label>
        <input formControlName="awayTeam" matInput placeholder="Enter Away Team Name"/>
      </mat-form-field>
    </div>

    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
      <mat-form-field appearance="outline" style="width: 45%;">
        <mat-label>League Type</mat-label>
        <input formControlName="leagueType" matInput placeholder="Enter league type"/>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 45%;">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option value="UPCOMING">Upcoming</mat-option>
          <mat-option value="LIVE">Live</mat-option>
          <mat-option value="FINISHED">Finished</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
      <mat-form-field appearance="outline" style="width: 45%;">
        <mat-label>Game Date</mat-label>
        <input [matDatepicker]="picker" [min]="date" formControlName="gameDate" matInput/>
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 45%;">
        <mat-label>Game Time</mat-label>
        <input formControlName="gameTime" matInput type="time"/>
      </mat-form-field>
    </div>

  </div>

  <div mat-dialog-actions style="display: flex; justify-content: space-around">
    <button (click)="cancel()" color="primary" mat-raised-button>{{'Cancel' | translate}}</button>
    <button (click)="saveGame()" color="primary" mat-raised-button>
      {{ 'Create Nationals Games' | translate }}
    </button>
  </div>
</form>
